const state = {
  authority: {
    accountId: null,
    brandInfos: [],
    menus: {},
    workplace: {}
  },
  userDetails: {
    workPlaceId: '',
    loginId: '',
    name: '',
    email: '',
    accountsType: ''
  }
};

const getters = {
  getWorkPlaceId: (state) => {
    return state.userDetails.workPlaceId;
  },
  getLoginId: (state) => {
    return state.userDetails.loginId;
  },
  isOwner: (state) => {
    return state.userDetails.accountsType === 'OWNER';
  },
  isBrandManager: (state) => {
    return state.userDetails.accountsType === 'BRAND_MANAGER';
  },
  isMember: (state) => {
    return state.userDetails.accountsType === 'MEMBER';
  },
  getBrands: (state) => {
    return state.authority.brandInfos;
  },
  isMultiBrand: (state) => {
    return state.authority.brandInfos.length > 1;
  },
  getFirstBrandsId: (state) => {
    return state.authority.brandInfos && state.authority.brandInfos.length > 0 && state.authority.brandInfos[0].id;
  },
  getBrandAuthority: (state) => {
    return state.authority.menus;
  },
  getUserDetails: (state) => {
    return state.userDetails;
  },
  getAccountId: (state) => {
    return state.userDetails.accountId;
    // 업데이트 시점이 느려서 변경 return state.authority.accountId;
  },
  getWorkplace: () => {
    return state.authority.workplace;
  },
  // <!-- 커스텀 옵션 검색
  getSearchCustomOption: (state) => (brandId, optionName) => {
    let find = false;
    state.authority.brandInfos.find((el) => {
      if (el.id === brandId) {
        el.customOptions.find((option) => {
          if (option.definitionName === optionName) find = true;
        });
      }
    });
    return find;
  },
  getSearchCustomOptionObj: (state) => (brandId, optionName) => {
    // 옵션 세부 내용이 담긴 customOptionJson 객체 리턴
    const findBrandInfo = state.authority.brandInfos.find((el) => Number(el.id) === Number(brandId));
    let customOption = null;
    if (findBrandInfo) {
      customOption = findBrandInfo.customOptions.find((f) => f.definitionName === optionName);
    }
    return customOption ? customOption.customOptionJson : {};
  },
  getCustomOptionListInWorkplace: (state) => (optionName) => {
    // 워크플레이스에 속한 모든 브랜드로부터 특정 이름의 커스텀 옵션을 찾아서 배열로 리턴
    return state.authority.brandInfos
      .map((el) => {
        const option = el.customOptions.find((option) => option.definitionName === optionName);
        return option && option.customOptionJson;
      })
      .filter(Boolean);
  },
  isWorkplaceUsingCustomOption: (state) => (customOptionName) => {
    // 전체 브랜드 가운데 적어도 한 브랜드에서 특정 이름의 커스텀 옵션을 사용하는지 여부 반환
    // 워크플레이스 기준으로 검색하기 위해 추가된 함수
    return state.authority.brandInfos.some((item) =>
      item.customOptions.some((option) => option.definitionName === customOptionName && option.customOptionJson.use === true)
    );
  },
  isWorkplaceUsingChannel: (state) => (channelName) => {
    // 전체 브랜드 가운데 적어도 한 브랜드에서 특정 이름의 채널을 사용하는지 여부 반환
    // 워크플레이스 기준으로 검색하기 위해 추가된 함수
    return state.authority.brandInfos.some(
      (brand) =>
        Array.isArray(brand.moduleChannels) &&
        brand.moduleChannels.some(
          (channel) =>
            channel.channelName &&
            channel.channelName.code === channelName &&
            channel.channelStatusType &&
            channel.channelStatusType.code === 'APPROVAL'
        )
    );
  },
  isBrandUsingChannel: (state) => (brandId, channel) => {
    // 특정 브랜드가 특정 채널을 사용하는지 여부 반환
    const brand = state.authority.brandInfos.find((brand) => brand.id === brandId);
    if (!brand || !Array.isArray(brand.moduleChannels)) return false;
    return brand.moduleChannels.some(
      (ch) => ch.channelName && ch.channelName.code === channel && ch.channelStatusType && ch.channelStatusType.code === 'APPROVAL'
    );
  },
  getWorkplaceCustomOption: (state) => (customOptionName) => {
    const workPlacesCustomOptionList = state.authority.workplace.workPlacesCustomOptions;
    if (!workPlacesCustomOptionList) return {};
    const customOption = workPlacesCustomOptionList.find((f) => f.workPlacesCustomName.code === customOptionName);
    return customOption || {};
  },
  getWorkplaceCustomOptionUseStatus: (state) => (customOptionName) => {
    const workPlacesCustomOptionList = state.authority.workplace.workPlacesCustomOptions;
    if (!workPlacesCustomOptionList) return false;
    const customOption = workPlacesCustomOptionList.find((f) => f.workPlacesCustomName.code === customOptionName);
    if (!customOption) return false;
    return customOption && customOption.useStatus.code === 'ENABLE';
  },
  // 커스텀 옵션 검색  -->
  getBrandInfoByIdAndKey: (state) => (payload) => {
    const { key, brandId } = payload;
    const brand = state.authority.brandInfos.find((brand) => brand.id === brandId);
    return brand[key];
  },
  hasCallAISummaryOption: (state) => {
    // 워크플레이스의 STT 사용여부 대신 (해당 워크플레이스 내의 콜 AI 상담요약 사용하는 경우, STT는 기본적으로 사용하는 워크플레이스로 간주)
    // TODO: 추후에 STT 사용여부가 분리되면 해당 내용 변경 필요
    return !!state.authority.brandInfos.find((brand) =>
      brand.customOptions.find((option) => option.definitionName === 'AI' && option.customOptionJson.useCallSummary === true)
    );
  },
  hasChatAISummaryOption: (state) => {
    // MARK: 톡 상담데스크 진입 시 톡 AI 상담요약 사용하는 브랜드 있는 워크플레이스의 경우 AI 상담요약 완료된 keys 조회 하는 API 요청하기 위한 flag
    return !!state.authority.brandInfos.find((brand) =>
      brand.customOptions.find((option) => option.definitionName === 'AI' && option.customOptionJson.useChatSummary === true)
    );
  },
  // 1:1 문의 채널 연동한 경우 (브랜드 설정 하위의 1:1 문의 관련한 메뉴들과 UI 표시 분기처리 위해 사용)
  useContactSupportChannel: (state) => () => {
    let find = false;
    state.authority.brandInfos.find((el) => {
      if (!Array.isArray(el.moduleChannels)) return false;
      el.moduleChannels.forEach((channel) => {
        if (channel && channel.channelName && channel.channelName.code === 'CONTACT_SUPPORT') {
          const dataJson = channel.data ? JSON.parse(channel.data) : {};
          if (dataJson && dataJson.use === true) {
            find = true;
          }
        }
      });
    });
    return find;
  },
  hasCallTransferOption: (state) => {
    // 콜 녹취 기능 커스텀 옵션 사용
    return !!state.authority.brandInfos.find((brand) =>
      brand.customOptions.find((option) => option.definitionName === 'CALL' && option.customOptionJson.useCallPermission === true)
    );
  },
  getIsBrandUsingAiCallBot: (state) => (brandId) => {
    // AI 콜봇 사용 여부 반환
    let isUsingAiCallBot = false;
    try {
      const brandInfo = state.authority.brandInfos.find((el) => Number(el.id) === Number(brandId));
      const customOption = brandInfo.customOptions.find((f) => f.definitionName === 'CALL_BOT');
      isUsingAiCallBot = customOption.customOptionJson.use;
    } catch (_) {
      isUsingAiCallBot = false;
    }
    return isUsingAiCallBot;
  }
};

const mutations = {
  setAgentAuthority(state, authorityData) {
    state.authority = authorityData;
  },
  setUserDetails(state, userData) {
    state.userDetails = userData;
  },
  setBrandInfoByIdAndKey(state, payload) {
    const { key, brandId, value } = payload;
    const brandIdList = state.authority.brandInfos.map((brand) => brand.id);
    const brandIndex = brandIdList.indexOf(brandId);
    state.authority.brandInfos[brandIndex][key] = value;
  }
};
const actions = {
  async getMyMenu(context, { http, catchCallback }) {
    try {
      const rs = await http({
        method: 'GET',
        url: '/api/v1/my/menus'
      });

      let res = rs.data;
      localStorage.setItem('agent-authority', JSON.stringify(res));

      context.commit('setAgentAuthority', res);
      await Promise.resolve();
    } catch (e) {
      catchCallback();
      await Promise.reject(e);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/workplace/index.js